module.exports = __webpack_public_path__ + "catalog/items/text-3d/img.png";